export default {"src":"/_next/static/media/VLO.40178536.svg","height":18,"width":18};